import React, { createContext, useEffect, useState } from "react"
import { Amplify, API, Auth } from "aws-amplify"
import awsconfig from "../aws-exports"
// import { CognitoUserInterface } from "@aws-amplify/ui-components"

Amplify.configure(awsconfig)

// console.log("current config object", Auth.configure())
// Amplify.configure({
//   Auth: {
//     identityPoolId: "us-east-1:99b27d2b-4a8b-4947-be73-738171241395",
//     region: "us-east-1",
//     userPoolId: "us-east-1_leX6JfyUw",
//     userPoolWebClientId: "68uteemf2r9m96fm2gk4vuu71g",
//   },
// })
// console.log("updated  config object", Auth.configure())

enum OrganizationTypeEnum {
  HYBRID = "HYBRID",
  CONTENT = "CONTENT",
  EVENT = "EVENT",
}

export interface OrganizationAttributes {
  id: string
  name: string
  handle: string
  type: OrganizationTypeEnum
  planID?: string
  entitlements?: any
  paymentConfig?: any
  onboarding?: any
  baseType?: string
  metrics?: any
  createdAt?: string
  updatedAt?: string
  owner?: string
  purchaserID?: string
}

interface OrganizationState {
  currentOrganization: OrganizationAttributes | any
  updateOrganization: (org: OrganizationAttributes) => Promise<void>
  reloadOrganization: () => Promise<OrganizationAttributes | undefined>
}

export const OrganizationContext = createContext<OrganizationState>({
  currentOrganization: {
    id: "",
    name: "",
    handle: "",
    type: OrganizationTypeEnum.EVENT,
  },
  updateOrganization: async () => undefined,
  reloadOrganization: async () => undefined,
})

interface OrganizationProviderProps {
  children: React.ReactNode
}

const OrganizationProvider = ({ children }: OrganizationProviderProps) => {
  const [currentOrganization, setCurrentOrganization] =
    useState<OrganizationAttributes>()
  // const { cognitoUser } = useContext(AuthContext)

  useEffect(() => {
    const loadOrg = async () => {
      await fetchOrganization()
    }
    if (!currentOrganization) {
      loadOrg()
    } else {
      // console.log("current Organization", currentOrganization)
    }
    // console.log("ORGCONTEXT: Initial organization loading")
  }, [])

  // useEffect(() => {
  //   if (!cognitoUser) {
  //     setCurrentOrganization(undefined)
  //   }
  // }, [cognitoUser])

  const reloadOrganization = async () => {
    const reloadedOrg = await fetchOrganization()
    // console.log("ORGCONTEXT: reloading Organization...", reloadedOrg)
    return reloadedOrg
  }
  async function getOrgHandle() {
    try {
      const user = await Auth.currentUserInfo()
      // console.log("user", user)
      let orgHandle = user ? user?.attributes["custom:organization"] : null
      // console.log("orgHandle", orgHandle)
      orgHandle = orgHandle?.replace(/\W+(?!$)/g, "-")?.toLowerCase()
      orgHandle = orgHandle?.replace(/\W$/, "")?.toLowerCase()
      return orgHandle
    } catch {
      // console.log("FETCH ORGANIZATION no current user")
      return null
    }
  }

  const fetchOrganization = async () => {
    try {
      const possibleToken = (await Auth.currentSession())
        .getIdToken()
        .getJwtToken()
      const handle = await getOrgHandle()
      const requestPath = "/org?handle=" + handle
      const requestInfo = {
        headers: { Authorization: possibleToken },
      }
      if (handle) {
        let currentOrg = await API.get("azingorest", requestPath, requestInfo)
        if (currentOrg?.body?.onboarding) {
          const currentProfileProgress = await getProfileProgress()
          currentOrg.body.onboarding.profileProgress = currentProfileProgress
        }
        // console.log("FETCH ORGANIZATION:", currentOrg)
        setCurrentOrganization(currentOrg?.body)
        return currentOrg?.body
      }
    } catch (error) {
      console.log("FETCH ORGANIZATION error:", error)
    }
    return undefined
  }

  const getProfileProgress = async () => {
    const user = await Auth.currentUserInfo()
    const stringAddess: any = user?.attributes?.address
    const familyName = user?.attributes?.family_name
    const phoneNumber = user?.attributes?.phone_number
    const givenName = user?.attributes?.given_name
    const address = JSON.parse(stringAddess)
    const country = address?.country
    // const state = address?.region
    // const postal = address?.postal_code
    // const place_id = address?.place_id
    // const address1 = address?.street_address
    // address2 = user ? address?.street_address?.split(",")?.[0] : ""
    // const city = address?.locality

    let percentage = 0

    if (givenName) {
      percentage += 25
    }
    if (familyName) {
      percentage += 25
    }
    if (phoneNumber) {
      percentage += 25
    }
    if (country) {
      percentage += 25
    }
    // console.log("Profile Progress for: ", user?.attributes)
    // console.log("Profile Progress: ", percentage)
    return percentage
  }

  const updateOrganization = async (input: OrganizationAttributes) => {
    // console.log("ORGCONTEXT: Updating Org with:", input)
    // const signedInUser: CognitoUserInterface | null = await getSignedInUser()
    // const authToken = signedInUser?.signInUserSession?.idToken?.jwtToken
    let newOrgInfo = input
    try {
      const currentProfileProgress = await getProfileProgress()
      newOrgInfo.onboarding.profileProgress = currentProfileProgress

      if (!newOrgInfo.purchaserID) {
        const user = await Auth.currentUserInfo()
        newOrgInfo.purchaserID = user?.attributes?.sub
      }
    } catch {}
    try {
      const possibleToken = (await Auth.currentSession())
        .getIdToken()
        .getJwtToken()
      const requestInfo = {
        headers: { Authorization: possibleToken },
        body: newOrgInfo,
      }
      // console.log("OrgInfo sent to Lambda:", newOrgInfo)

      const currentOrg = await API.post("azingorest", "/org", requestInfo)
      // console.log("ORGCONTEXT REST response for UPDATE:", currentOrg)
      setCurrentOrganization(currentOrg?.body)
    } catch (error) {
      console.log("update Org error:", error)
    }
  }

  return (
    <OrganizationContext.Provider
      value={{
        currentOrganization,
        updateOrganization,
        reloadOrganization,
      }}
    >
      {children}
    </OrganizationContext.Provider>
  )
}

export default OrganizationProvider
